import Reflux from 'reflux';
import EventData from 'shared/data/Event';

let async = { asyncResult: true },
  TagEditFormActions = Reflux.createActions({
    updateField: {},
    submit: {},
    update: async,
    populate: {},
    clear: {},
  });

TagEditFormActions.update.listenAndPromise(EventData.updateLabel);

export default TagEditFormActions;
